import http from './http';

export default {
  all() {
    return http().get(`/v1/follow_up_sequences/`);
  },
  get(id) {
    return http().get(`/v1/follow_up_sequences/${id}`);
  },
  getDictionary(followUpIds) {
    return http().post(`/v1/follow_up_sequences/dictionary`, {
      follow_up_ids: followUpIds
    });
  },
  getSteps(id) {
    return http().get(`/v1/follow_up_sequences/${id}/steps`);
  },
  create (data) {
    return http().post(`/v1/follow_up_sequences`, data);
  },
  update (data) {
    return http().post(`/v1/follow_up_sequences/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/follow_up_sequences/${id}`);
  },
  complete(id) {
    return http().put(`/v1/follow_up_sequences/${id}/complete`);
  },
  // getPendingSteps() {
  //   // TODO: delete this and the corrosponding view if we do not need it.
  //   return http().get(`/v1/follow_up_sequences/pending_steps`);
  // },
  pause(fusId) {
    return http().put(`/v1/follow_up_sequences/${fusId}/pause`);
  },
  resume(fusId) {
    return http().put(`/v1/follow_up_sequences/${fusId}/resume`);
  },
  cancel(fusId) {
    return http().put(`/v1/follow_up_sequences/${fusId}/cancel`);
  },
  timeline() {
    if (process.env.MIX_USE_MOCK === 'true') {
      return Promise.resolve({
        data: timeline
      });
    }

    return http().get(`/v1/follow-up/timeline`);
  },
  records() {
    if (process.env.MIX_USE_MOCK === 'true') {
      return Promise.resolve({
        data: records
      });
    }

    return http().get(`/v1/follow-up/records`);
  }
}

let timeline = [
  {
    id: 1,
    date: '2019-08-05 09:00:00',
    type: 'text',
    record_id: 3,
    follow_up_sequence_id: 1,
    user_id: 1,
    created_at: '2019-06-21 13:37:09',
    createdBy: {
      id: 1,
      name: 'William Roberts'
    },
    updated_at: '2019-06-21 13:37:09',
    updatedBy: {
      id: 1,
      name: 'William Roberts'
    }
  },
  {
    id: 2,
    date: '2019-08-08 11:00:00',
    type: 'text',
    record_id: 3,
    follow_up_sequence_id: 1,
    user_id: 1,
    created_at: '2019-06-21 13:37:09',
    createdBy: {
      id: 1,
      name: 'William Roberts'
    },
    updated_at: '2019-06-21 13:37:09',
    updatedBy: {
      id: 1,
      name: 'William Roberts'
    }
  }
];

let records = [
  {
    id: 1,
    created_at: '2019-06-21 13:37:09',
    createdBy: {
      id: 1,
      name: 'William Roberts'
    },
    updated_at: '2019-06-21 13:37:09',
    updatedBy: {
      id: 1,
      name: 'William Roberts'
    }
  }
];

let sequences = [
  {
    id: 1,
    created_at: '2019-06-21 13:37:09',
    createdBy: {
      id: 1,
      name: 'William Roberts'
    },
    updated_at: '2019-06-21 13:37:09',
    updatedBy: {
      id: 1,
      name: 'William Roberts'
    }
  }
];
